import { render, staticRenderFns } from "./Marketing_solicitudes_piezas.vue?vue&type=template&id=0a6f31fb&"
import script from "./Marketing_solicitudes_piezas.vue?vue&type=script&lang=js&"
export * from "./Marketing_solicitudes_piezas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports